import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const HARD_DELETE_THREAD_MESSAGES = createAsyncActionTypes('HARD_DELETE_THREAD_MESSAGES');
export const DELETE_THREAD_MESSAGE = createAsyncActionTypes('DELETE_THREAD_MESSAGE');
export const RESTORE_MESSAGE = createAsyncActionTypes('RESTORE_MESSAGE');
export const FETCH_DELETED_MESSAGES = createAsyncActionTypes('FETCH_DELETED_MESSAGES');